export default __webpack_public_path__ + "maps-examples-clustering-thumbnail-480-6b10ac21195873751c244cd487aa9f61.webp";